import { useAppSelector } from '@pkg/hooks';

import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import { useGetGroupMembers } from './useGetGroupMembers';
import { useGroupId } from './useGroupId';
import { getPagesContent } from './utils';

/**
 * React Hook using React Query to determine if the
 * current user is a member of the current Pod.
 */
// TODO: I wouldn't think this hook should be required,
// since we get `is_member` from `useGetGroup() > data`.
// However, that hook does not appear to update `data`
// when the `members` changes.
export function useIsGroupMember(defaultGroupId = '') {
    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);

    const currentUserId = useAppSelector((state) => state.user?.userAccount?.user.id);
    // Todo this should come via props
    const groupId = useGroupId() || defaultGroupId;

    const { data } = useGetGroupMembers({ isAuthenticated, groupId });

    const membersData = getPagesContent(data?.pages);
    // If we require a distinction between "not a member" and "not logged in",
    // we can consider returning `undefined` not there is no `currentUserId`.
    return !currentUserId || !membersData ? false : membersData.some(({ user_id }) => user_id === currentUserId);
}
